import { z } from "zod";

export const UPDATE_AD_REPORT_VIEW_MODEL_SCHEMA = z.object({
  PK: z.string().min(1, "PK is required"),
  SK: z.string().min(1, "SK is required"),
  email: z.string().min(1, "Email is required"),
  details: z.string(),
});

export type UpdateAdReportViewModel = z.infer<
  typeof UPDATE_AD_REPORT_VIEW_MODEL_SCHEMA
>;
